import { V2 } from "./V2";

export default V2;
